import { Controller, useFormContext } from 'react-hook-form';
import { forwardRef } from 'react';
import BaseFormattedTextField, {
  BaseFormattedTextFieldProps,
  ErrorHelperTextStyle as _ErrorHelperTextStyle,
} from '@/components/CustomTextInput2/BaseFormattedTextField';

export { _ErrorHelperTextStyle as ErrorHelperTextStyle }; // ✅ 레거시 경로 호환

export type RHFTextFieldProps = Omit<
  BaseFormattedTextFieldProps,
  'value' | 'onValueChange'
> & {
  readonly name: string;
  /** 표시만 덮어쓸 때 (RHF 값 변경 없이 UI 표기 용) */
  readonly value?: BaseFormattedTextFieldProps['value'];
};

const RHFTextField = forwardRef<HTMLDivElement, RHFTextFieldProps>(
  ({ name, value: displayOverride, ...rest }, ref) => {
    const { control, clearErrors } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <BaseFormattedTextField
            ref={ref}
            {...rest}
            error={!!error}
            // 표시값 우선순위: 외부 override > RHF 값
            value={displayOverride ?? field.value}
            onValueChange={(v) => {
              field.onChange(v);
              if (v !== '' && error) clearErrors(name);
            }}
          />
        )}
      />
    );
  },
);

RHFTextField.displayName = 'RHFTextField';
export default RHFTextField;
